import { render, staticRenderFns } from "./paymentType.vue?vue&type=template&id=5251c748&scoped=true&"
import script from "./paymentType.vue?vue&type=script&lang=js&"
export * from "./paymentType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5251c748",
  null
  
)

export default component.exports